/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledCell = styled.div<{ $editable?: boolean }>`
    position: relative;
    display: inline-block;
    width: 100%;
    cursor: ${({ $editable }) => ($editable ? 'pointer' : 'default')};
`;

export const StyledCellValue = styled.span<{ $isEditing?: boolean }>`
    display: block;
    width: 100%;
    text-align: center;
    white-space: nowrap;
    font: inherit;
    visibility: ${({ $isEditing }) => ($isEditing ? 'hidden' : 'visible')};
`;

export const StyledCellInput = styled.input<{ $isEditing?: boolean }>`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
    outline: none;
    text-align: center;
    padding: 0;
    margin: 0;
    font: inherit;
    opacity: ${({ $isEditing }) => ($isEditing ? 1 : 0)};
    pointer-events: ${({ $isEditing }) => ($isEditing ? 'auto' : 'none')};
`;
